function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 297 208"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "297",
  height: "208",
  rx: "5",
  fill: "#FFF4BC"
}), /*#__PURE__*/React.createElement("rect", {
  x: "95",
  y: "26",
  width: "101.883",
  height: "101.883",
  rx: "39.186",
  fill: "#FFD300"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.246 85.284c0-3.894 1.593-7.61 4.071-10.265h-12.919c2.478 2.655 4.07 6.371 4.07 10.265 0 7.432-5.486 13.803-12.741 14.865v4.955h30.084v-4.955c-7.079-1.062-12.565-7.256-12.565-14.865z",
  fill: "#F6FFDB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.651 69.357h-41.588c-3.539 0-6.547-3.008-6.547-6.547 0-3.54 2.831-6.548 6.547-6.548h41.765c3.539 0 6.548 3.008 6.548 6.547 0 3.54-3.009 6.548-6.725 6.548z",
  stroke: "#FDFF9F",
  strokeWidth: "2.225"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.831 105.284h38.225c.531 0 1.062-.531 1.062-1.062v-4.07c0-.531-.531-1.062-1.062-1.062h-38.225c-.531 0-1.061.53-1.061 1.062v4.07c0 .531.53 1.062 1.061 1.062zM160.633 47.944h-34.332v14.689c0 5.486 1.946 10.795 5.132 14.688 3.185 3.716 7.433 6.37 12.388 6.902 11.679 1.239 21.59-8.672 21.59-21.06V47.945h-4.778z",
  fill: "#F6FFDB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.433 175.34c-5.746 0-9.112-4.284-9.112-10.268 0-6.324 3.434-10.88 10.132-10.88 5.508 0 8.568 3.128 9.316 8.058l-3.638.714c-.714-3.434-2.516-5.304-5.848-5.304-4.25 0-6.086 3.06-6.086 7.412 0 3.944 1.87 6.936 6.528 6.936 4.318 0 5.542-1.972 5.542-4.148v-.272h-6.018v-3.434h9.69V175h-3.672v-4.726h-.068c-.68 2.856-2.788 5.066-6.766 5.066zm21.133.102c-5.134 0-8.194-3.23-8.194-8.466 0-5.27 3.264-8.364 8.194-8.364 4.896 0 8.16 3.094 8.16 8.364 0 5.236-3.094 8.466-8.16 8.466zm0-13.498c-2.856 0-4.522 1.938-4.522 4.998 0 3.094 1.598 5.134 4.488 5.134 2.924 0 4.556-2.04 4.556-5.134 0-3.06-1.7-4.998-4.522-4.998zm14.426-7.786V175h-3.672v-20.842h3.672zm10.375 17.952c2.618 0 4.25-1.768 4.25-4.93v-.272c0-3.06-1.632-5.032-4.25-5.032-2.788 0-4.148 1.904-4.148 5.202 0 3.196 1.292 5.032 4.148 5.032zm4.25 2.89v-4.522h-.068c-.714 3.23-2.584 4.964-5.678 4.964-4.148 0-6.29-3.196-6.29-8.364 0-5.304 2.278-8.5 6.29-8.466 3.196-.034 4.998 1.7 5.712 4.998h.034v-9.452h3.672V175h-3.672z",
  fill: "#2D2E2E"
})));